// extracted by mini-css-extract-plugin
export default {"folder-list":"folder-list--kdsLwfTOFY","folderList":"folder-list--kdsLwfTOFY"};